import { render } from "./LotteryCreate.vue?vue&type=template&id=50a7e6f5&scoped=true"
import script from "./LotteryCreate.vue?vue&type=script&lang=js"
export * from "./LotteryCreate.vue?vue&type=script&lang=js"

import "./LotteryCreate.vue?vue&type=style&index=0&id=50a7e6f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a7e6f5"]])

export default __exports__